import * as React from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import SubjectRenameEditor from "../../SubjectRenameEditor";
import {BaseConfigureSubjectMergesPage, BaseConfigureSubjectMergesPageProps} from "./BaseConfigureSubjectMergesPage";
import { Fragment } from "react";
import SchoolPageTitle from "../../SchoolPageTitle";
import AdminSchoolMenu from "../../AdminSchoolMenu";


class ConfigureSubjectRenamesPage extends BaseConfigureSubjectMergesPage {

    constructor(props: BaseConfigureSubjectMergesPageProps & DispatchProps) {
        super(props);
        this.state = {
            saveInProgress: false,
            helpContent: <span>Rename subjects below</span>,
            helpIcon: "Edit",
            helpTitleText: "Rename Subjects",
        };
    }
    
    protected renderContent(): JSX.Element
    {
        if(this.state.subjectMerges === undefined || this.state.sdsSubjects == undefined || this.state.subjectExcludes == undefined)
        {
            return <div/>;
        }
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Subject Renames" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <SubjectRenameEditor onMergesChanged={
                    (subjectMerges) => {
                        this.setState({ subjectMerges: subjectMerges });
                    }}
                    sdsSubjects={this.state.sdsSubjects}
                    subjectMerges={this.state.subjectMerges}
                    subjectExcludes={this.state.subjectExcludes}
                />
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): BaseConfigureSubjectMergesPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };

    }
)(ConfigureSubjectRenamesPage)